import React from 'react';
import { useNavigate } from 'react-router-dom';
import NavBar from '../components/NavBar';
import Footer from '../components/Footer';

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '2rem',
    flex: '1 0 auto'
  },
  title: {
    fontSize: '2rem',
    fontWeight: 'bold',
    marginBottom: '1rem',
    color: '#4F46E5'
  },
  message: {
    fontSize: '1.2rem',
    marginBottom: '2rem',
    color: '#6B7280',
    textAlign: 'center',
    maxWidth: '600px'
  },
  button: {
    padding: '0.5rem 1.5rem',
    backgroundColor: '#4F46E5',
    color: 'white',
    border: 'none',
    borderRadius: '0.25rem',
    fontSize: '1rem',
    cursor: 'pointer',
    transition: 'background-color 0.2s'
  }
};

function NotAvailablePage({ title = "Coming Soon", message = "This feature is currently under development. Please check back later!" }) {
  const navigate = useNavigate();
  
  return (
    <div style={styles.container}>
      <NavBar />
      <div style={styles.content}>
        <h1 style={styles.title}>{title}</h1>
        <p style={styles.message}>{message}</p>
        <button 
          style={styles.button}
          onClick={() => navigate('/')}
        >
          Back to Home
        </button>
      </div>
      <Footer />
    </div>
  );
}

export default NotAvailablePage;
